export const DOCUMENT_TYPE_ABOUT_LANDING_PAGE = 'aboutLandingPage';
